export default __webpack_public_path__ + "static/0086-fc79197cda08ca04a8ad9049043d276e.png";